export default __webpack_public_path__ + "static/media/Formular-Medium.57229735.woff2";